import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './style.scss';
import jsPDF from 'jspdf';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit';
const PatternGeneratorBot = () => {
  const navigate = useNavigate();
  const [imageSrc, setImageSrc] = useState("");
  const [previewVisible, setPreviewVisible] = useState(false);
  const [showCamera, setShowCamera] = useState(false);
  const [videoStream, setVideoStream] = useState(null);
  const [currentFacingMode, setCurrentFacingMode] = useState("user");
  const [loading, setLoading] = useState(false);
  const [isGeneratingImage, setIsGeneratingImage] = useState(false);
  
  
  // State cho tin nhắn chat
  const [messages, setMessages] = useState([
    {
      sender: "bot",
      text: "Chào bạn! Hãy chọn các tùy chọn về màu sắc, hình dạng và kiểu vẽ để tôi tạo ra họa tiết vải cho bạn."
    }
  ]);
  const [userInput, setUserInput] = useState("");
  
  // State cho các tùy chọn họa tiết
  const [selectedColors, setSelectedColors] = useState([]);
  const [selectedShapes, setSelectedShapes] = useState([]);
  const [selectedPatterns, setSelectedPatterns] = useState([]);
  const [generatedPattern, setGeneratedPattern] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalImageUrl, setModalImageUrl] = useState("");
  
  // Refs
  const videoRef = useRef(null);
  const fileInputRef = useRef(null);
  const chatMessagesRef = useRef(null);
  
  // Danh sách màu sắc, hình dạng, kiểu vẽ
  const colorOptions = [
    { id: 'red', name: 'Đỏ', hex: '#e74c3c' },
    { id: 'blue', name: 'Xanh dương', hex: '#3498db' },
    { id: 'green', name: 'Xanh lá', hex: '#2ecc71' },
    { id: 'yellow', name: 'Vàng', hex: '#f1c40f' },
    { id: 'purple', name: 'Tím', hex: '#9b59b6' },
    { id: 'orange', name: 'Cam', hex: '#e67e22' },
    { id: 'black', name: 'Đen', hex: '#34495e' },
    { id: 'white', name: 'Trắng', hex: '#ffffff' },
    { id: 'brown', name: 'Nâu', hex: '#8d5524' },
    { id: 'pink', name: 'Hồng', hex: '#fd79a8' },
    { id: 'gray', name: 'Xám', hex: '#7f8c8d' },
    { id: 'beige', name: 'Vàng đất', hex: '#f5e6b2' },
    { id: 'silver', name: 'Bạc', hex: '#bdc3c7' },
    { id: 'gold', name: 'Vàng kim', hex: '#ffd700' },
  ];
  
  const shapeOptions = [
    { id: 'triangle', name: 'Tam giác' },
    { id: 'rhombus', name: 'Hình thoi' },
    { id: 'square', name: 'Hình vuông' },
    { id: 'rectangle', name: 'Hình chữ nhật' },
    { id: 'circle', name: 'Hình tròn' },
    { id: 'hexagon', name: 'Lục giác' },
  ];
  
  const patternOptions = [
    { id: 'interlaced', name: 'Đan xen' },
    { id: 'diagonal', name: 'Xiên' },
    { id: 'symmetric', name: 'Đối xứng' },
    { id: 'repeated', name: 'Lặp lại' },
    { id: 'random', name: 'Ngẫu nhiên' },
    { id: 'gradient', name: 'Chuyển màu' },
    { id: 'striped', name: 'Sọc' }
  ];

  // Xử lý màu sắc
  const handleColorSelect = (colorId) => {
    if (selectedColors.includes(colorId)) {
      setSelectedColors(selectedColors.filter(id => id !== colorId));
    } else {
      setSelectedColors([...selectedColors, colorId]);
    }
  };
  
  // Xử lý hình dạng
  const handleShapeSelect = (shapeId) => {
    if (selectedShapes.includes(shapeId)) {
      setSelectedShapes(selectedShapes.filter(id => id !== shapeId));
    } else {
      setSelectedShapes([...selectedShapes, shapeId]);
    }
  };
  
  // Xử lý kiểu vẽ
  const handlePatternSelect = (patternId) => {
    if (selectedPatterns.includes(patternId)) {
      setSelectedPatterns(selectedPatterns.filter(id => id !== patternId));
    } else {
      setSelectedPatterns([...selectedPatterns, patternId]);
    }
  };
  
  const addBotMessage = (text, imageUrl = null) => {
    setMessages(prev => [...prev, { sender: "bot", text, imageUrl }]);
    scrollChatToBottom();
  };

  const addUserMessage = (text) => {
    setMessages(prev => [...prev, { sender: "user", text }]);
    scrollChatToBottom();
  };

  const scrollChatToBottom = () => {
    if (chatMessagesRef.current) {
      setTimeout(() => {
        chatMessagesRef.current.scrollTop = chatMessagesRef.current.scrollHeight;
      }, 100);
    }
  };
  
  // Hiển thị modal ảnh
  const showImageModal = (imageUrl) => {
    setModalImageUrl(imageUrl);
    setModalVisible(true);
  };

  // Đóng modal ảnh
  const closeImageModal = () => {
    setModalVisible(false);
  };

  // Tạo prompt cho API
  const createImagePrompt = () => {
    const selectedColorsNames = selectedColors.map(id => 
      colorOptions.find(color => color.id === id).id
    ).join(', ');
    
    const selectedShapesNames = selectedShapes.map(id => 
      shapeOptions.find(shape => shape.id === id).id
    ).join(', ');
    
    const selectedPatternsNames = selectedPatterns.map(id => 
      patternOptions.find(pattern => pattern.id === id).id
    ).join(', ');

    return `
      This is a type of traditional ethnic fabric with intricate geometric patterns.
      The main motifs are ${selectedPatternsNames}.
      The color palette primarily includes ${selectedColorsNames} with white as the accent color.
      Each row alternates between large, bold ${selectedShapesNames} shapes outlined in gold or yellow 
      and smaller repeating motifs of zigzag and triangular patterns.
      The designs are arranged symmetrically, creating a rhythmic and balanced visual effect.
      ${userInput}
    `;
  };
  
  // Xử lý gọi API tạo ảnh
  const generateImageAPI = async () => {
    if (selectedColors.length === 0 || selectedShapes.length === 0 || selectedPatterns.length === 0) {
      addBotMessage("Vui lòng chọn ít nhất một màu sắc, một hình dạng và một kiểu vẽ để tạo họa tiết.");
      return;
    }

    setIsGeneratingImage(true);
    
    const selectedColorsNames = selectedColors.map(id => 
      colorOptions.find(color => color.id === id).name
    ).join(", ");
    
    const selectedShapesNames = selectedShapes.map(id => 
      shapeOptions.find(shape => shape.id === id).name
    ).join(", ");
    
    const selectedPatternsNames = selectedPatterns.map(id => 
      patternOptions.find(pattern => pattern.id === id).name
    ).join(", ");
    
    // Thêm thông báo đang tạo
    addBotMessage(`Đang tạo họa tiết vải với:
    - Màu sắc: ${selectedColorsNames}
    - Hình dạng: ${selectedShapesNames}
    - Kiểu vẽ: ${selectedPatternsNames}
    
    Vui lòng đợi trong giây lát...`);

    try {
      // Trong môi trường thực tế, bạn sẽ gọi API thực sự
      // Mô phỏng gọi API với fetch
      const imagePrompt = createImagePrompt();
      console.log("Image Prompt:", imagePrompt);
      const response = await fetch('https://my-api-sage-ten.vercel.app/api/generate-image', {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          prompt: imagePrompt,
          n: 1,
          size: "512x512"
        })
      });
      
      const data = await response.json();
      if (!response.ok) throw new Error(data.error);
      const imageUrl = data.data[0].url;
      

      setTimeout(() => {
        
        setGeneratedPattern(imageUrl);
        
        addBotMessage(`Đã tạo họa tiết vải với:
        - Màu sắc: ${selectedColorsNames}
        - Hình dạng: ${selectedShapesNames}
        - Kiểu vẽ: ${selectedPatternsNames}
        
        Bạn có thể tiếp tục chọn các tùy chọn khác để tạo họa tiết mới.`, imageUrl);
        
        setIsGeneratingImage(false);
      }, 3000);
      
    } catch (error) {
      console.error("Lỗi khi tạo ảnh:", error);
      addBotMessage("Đã xảy ra lỗi khi tạo họa tiết. Vui lòng thử lại sau.");
      setIsGeneratingImage(false);
    }
  };
  
  // Xử lý tạo họa tiết
  const generatePattern = () => {
    generateImageAPI();
  };
  
  // Xử lý lưu họa tiết
  const savePattern = async () => {
    if (!generatedPattern) return;
    let downloadUrl = generatedPattern;
    // Nếu là URL ngoài, tải qua proxy để tránh CORS và bảo toàn ảnh
    if (generatedPattern.startsWith('http')) {
      downloadUrl = 'https://my-api-sage-ten.vercel.app/api/image-proxy?url=' + encodeURIComponent(generatedPattern);
      try {
        const response = await fetch(downloadUrl);
        const blob = await response.blob();
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = 'hoatiet-vai.png';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        addBotMessage("Đã lưu họa tiết thành công!");
        return;
      } catch (err) {
        addBotMessage("Không thể tải ảnh qua proxy. Vui lòng thử lại.");
        return;
      }
    }
    // Nếu là base64/local, tải trực tiếp
    const downloadLink = document.createElement('a');
    downloadLink.href = downloadUrl;
    downloadLink.download = 'hoatiet-vai.png';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    addBotMessage("Đã lưu họa tiết thành công!");
  };
  
  // Xử lý chia sẻ họa tiết
  const sharePattern = () => {
    if (!generatedPattern) return;
    
    // Copy URL vào clipboard
    navigator.clipboard.writeText(generatedPattern)
      .then(() => {
        addBotMessage("Đã sao chép đường dẫn họa tiết vào clipboard. Bạn có thể chia sẻ ngay bây giờ!");
      })
      .catch(() => {
        addBotMessage("Không thể sao chép đường dẫn. Vui lòng thử lại.");
      });
  };
  
  // Hàm hỗ trợ: fetch ảnh về base64
  const fetchImageAsBase64 = async (url) => {
    try {
      let proxyUrl = url;
      if (url.startsWith('http')) {
        proxyUrl = 'https://my-api-sage-ten.vercel.app/api/image-proxy?url=' + encodeURIComponent(url);
      }
      const response = await fetch(proxyUrl);
      const blob = await response.blob();
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (err) {
      return null;
    }
  };

  // Hàm hỗ trợ: fetch font Noto Sans (Google Fonts, hỗ trợ tiếng Việt)
  const fetchFont = async () => {
    // NotoSans-Regular.ttf từ Google Fonts CDN (hoặc bạn có thể host riêng)
    const url = 'https://fonts.gstatic.com/s/notosans/v27/o-0IIpQlx3QUlC5A4PNb4g.ttf';
    const res = await fetch(url);
    return await res.arrayBuffer();
  };

  // Hàm xuất PDF dùng pdf-lib
  const exportToPDF = async () => {
    if (!generatedPattern) return;
    // Tạo PDF mới
    const pdfDoc = await PDFDocument.create();
    pdfDoc.registerFontkit(fontkit); 
    const page = pdfDoc.addPage([595.28, 841.89]); // A4 px (72dpi)

    // Font Unicode
    const fontBytes = await fetchFont();
    const notoFont = await pdfDoc.embedFont(fontBytes);

    // Thêm tiêu đề
    page.drawText('Họa tiết vải do AI của Caobangceritage tạo ra', {
      x: 150,
      y: 800,
      size: 24,
      font: notoFont,
      color: rgb(0, 0, 0),
    });

    // Thêm ảnh
    // Lấy ảnh base64
    let imgData = await fetchImageAsBase64(generatedPattern);
    if (!imgData) {
      alert('Không thể xuất PDF do ảnh nguồn không cho phép truy cập trực tiếp (CORS).');
      return;
    }
    // Loại bỏ tiền tố data:image/png;base64,
    const base64 = imgData.split(',')[1];
    const pngImage = await pdfDoc.embedPng(base64);
    const imgDims = pngImage.scale(1);
    // Tính toán vị trí ảnh
    const imgWidth = 400;
    const imgHeight = (imgDims.height / imgDims.width) * imgWidth;
    page.drawImage(pngImage, {
      x: 100,
      y: 800 - imgHeight - 40,
      width: imgWidth,
      height: imgHeight,
    });

    // Thông tin chi tiết
    const selectedColorsNames = selectedColors.map(id => colorOptions.find(color => color.id === id)?.name).join(', ');
    const selectedShapesNames = selectedShapes.map(id => shapeOptions.find(shape => shape.id === id)?.name).join(', ');
    const selectedPatternsNames = selectedPatterns.map(id => patternOptions.find(pattern => pattern.id === id)?.name).join(', ');
    const infoY = 800 - imgHeight - 80;
    page.drawText(`Màu sắc: ${selectedColorsNames}`, { x: 60, y: infoY, size: 14, font: notoFont, color: rgb(0,0,0) });
    page.drawText(`Hình dạng: ${selectedShapesNames}`, { x: 60, y: infoY - 20, size: 14, font: notoFont, color: rgb(0,0,0) });
    page.drawText(`Kiểu vẽ: ${selectedPatternsNames}`, { x: 60, y: infoY - 40, size: 14, font: notoFont, color: rgb(0,0,0) });
    page.drawText(`Ngày tạo: ${new Date().toLocaleString()}`, { x: 60, y: infoY - 60, size: 14, font: notoFont, color: rgb(0,0,0) });

    // Xuất file
    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'hoatiet-vai.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  const handleChatKeyDown = (e) => {
    if (e.key === "Enter") {
      if (!userInput.trim()) return;
      
      addUserMessage(userInput);
      
      // Xử lý câu hỏi của người dùng (đơn giản)
      if (userInput.toLowerCase().includes("tạo") || userInput.toLowerCase().includes("họa tiết")) {
        generatePattern();
      } else {
        addBotMessage("Để tạo họa tiết, hãy chọn các tùy chọn bên trái và nhấn nút 'Tạo họa tiết'.");
      }
      
      setUserInput("");
    }
  };
  
  useEffect(() => {
    scrollChatToBottom();
  }, [messages]);
  
  // Format markdown thành HTML
  const formatMarkdownToHTML = (markdown) => {
    const lines = markdown.split('\n');
    const htmlLines = [];
    let listBuffer = [];
    const flushList = () => {
      if (listBuffer.length > 0) {
        htmlLines.push('<ul>');
        htmlLines.push(...listBuffer);
        htmlLines.push('</ul>');
        listBuffer = [];
      }
    };
    lines.forEach(line => {
      const trimmedLine = line.trim();
      if (trimmedLine === '') {
        flushList();
        htmlLines.push('');
        return;
      }
      const headerMatch = trimmedLine.match(/^(#{1,6})\s+(.*)$/);
      if (headerMatch) {
        flushList();
        const level = headerMatch[1].length;
        htmlLines.push(`<h${level}>${headerMatch[2]}</h${level}>`);
        return;
      }
      if (trimmedLine.startsWith('-')) {
        listBuffer.push(`<li>${trimmedLine.replace(/^-+\s*/, '')}</li>`);
        return;
      }
      flushList();
      htmlLines.push(`<p>${trimmedLine}</p>`);
    });
    flushList();
    let html = htmlLines.join('\n');
    html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    html = html.replace(/\*(.*?)\*/g, '<em>$1</em>');
    return html;
  };
  
  // Component hiển thị spinner loading
  const LoadingSpinner = () => (
    <div className="loading-spinner">
      <div className="spinner"></div>
      <p>Đang tạo họa tiết...</p>
    </div>
  );
  
  return (
    <div className='container-pattern-generator'>
        <div className="pattern-chat-header">
            <button className="theme-btn" onClick={() => navigate('/')}>
            Trang chủ
            </button>
            <h2>AI TẠO HỌA TIẾT VẢI</h2>  
        </div>
        <div className="pattern-chat-section">
            <div className="pattern-options-container">
                {/* Phần tùy chọn màu sắc */}
                <div className="option-section">
                 <h3>Màu sắc</h3>
                  <div className="color-options">
                      {colorOptions.map(color => (
                      <div 
                          key={color.id}
                          className={`color-option ${selectedColors.includes(color.id) ? 'selected' : ''}`}
                          style={{ backgroundColor: color.hex }}
                          title={color.name}
                          onClick={() => handleColorSelect(color.id)}
                      >
                          {selectedColors.includes(color.id) && <span className="checkmark">✓</span>}
                      </div>
                      ))}
                  </div>
                </div>
                
                {/* Phần tùy chọn hình dạng */}
                <div className="option-section">
                    <h3>Hình dạng</h3>
                  <div className="shape-options">
                      {shapeOptions.map(shape => (
                      <div 
                          key={shape.id}
                          className={`shape-option ${selectedShapes.includes(shape.id) ? 'selected' : ''}`}
                          onClick={() => handleShapeSelect(shape.id)}
                      >
                          {shape.name}
                      </div>
                      ))}
                  </div>
                </div>
                
                {/* Phần tùy chọn kiểu vẽ */}
                <div className="option-section">
                  <h3>Kiểu vẽ</h3>
                  <div className="pattern-options">
                    {patternOptions.map(pattern => (
                    <div 
                        key={pattern.id}
                        className={`pattern-option ${selectedPatterns.includes(pattern.id) ? 'selected' : ''}`}
                        onClick={() => handlePatternSelect(pattern.id)}
                    >
                        {pattern.name}
                    </div>
                    ))}
                  </div>
                </div>
                
                <div className="pattern-actions">
                  <button 
                      className="generate-btn" 
                      onClick={generatePattern}
                      disabled={isGeneratingImage}
                  >
                      {isGeneratingImage ? 'Đang tạo...' : 'Tạo họa tiết'}
                  </button>
                 
                </div>
              </div>
              
              {/* Chat section */}
              <div className='pattern-chat-area'> 
                <div className="pattern-chat-messages" ref={chatMessagesRef}>
                    {messages.map((msg, index) => (
                    <div
                        key={index}
                        className={msg.sender === "user" ? "user-message" : "bot-message"}
                    >
                        <div
                          className="message-text"
                          dangerouslySetInnerHTML={{
                              __html: formatMarkdownToHTML(msg.text)
                          }}
                        ></div>
                        {msg.imageUrl && (
                          <div className="image-wrapper">
                            <img 
                              src={msg.imageUrl} 
                              alt="Generated Pattern" 
                              className="generated-image"
                              onClick={() => showImageModal(msg.imageUrl)}
                            />
                          </div>
                        )}
                    </div>
                    ))}
                    {isGeneratingImage && (
                      <div className="loading-message">
                        <LoadingSpinner />
                      </div>
                    )}
                </div>
              <div className="pattern-chat-input-area">
                  <input
                  type="text"
                  placeholder="Hỏi về họa tiết vải..."
                  value={userInput}
                  onChange={(e) => setUserInput(e.target.value)}
                  onKeyDown={handleChatKeyDown}
                  disabled={isGeneratingImage}
                  />
                  <button 
                    onClick={() => handleChatKeyDown({ key: 'Enter' })}
                    disabled={isGeneratingImage || !userInput.trim()}
                  >
                    Gửi
                  </button>
              </div>
            </div>
        </div>
        
        {/* Modal hiển thị ảnh */}
        {modalVisible && (
          <div className="image-modal" onClick={closeImageModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <span className="close-button" onClick={closeImageModal}>&times;</span>
              <img src={modalImageUrl} alt="Pattern Preview" className="modal-image" />
              <div className="modal-actions">
                <button className="modal-btn download-btn" onClick={savePattern}>Tải xuống</button>
                <button className="modal-btn share-btn" onClick={sharePattern}>Chia sẻ</button>
                <button className="modal-btn pdf-btn" onClick={exportToPDF}>Xuất PDF</button>
              </div>
            </div>
          </div>
        )}
    </div>
  );
};

export default PatternGeneratorBot;